import { connect } from 'react-redux';
import { Props } from './Overlay';

import { getIsFavourite } from '../../../../CollectionPanel/redux/selectors';
import { getHasCommentedOnDeviation } from '../../../../redux/deviations/selectors';

export type StateProps = Pick<Props, 'isFaved' | 'hasCommentedOn'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps = (state, { deviation }: OwnProps): StateProps => {
  return {
    isFaved: getIsFavourite(state, deviation),
    hasCommentedOn: getHasCommentedOnDeviation(state, deviation),
  };
};

export default connect(mapStateToProps);
